import { Aviso, BaseResourceModel } from 'eddydata-lib';

export class AvisoStorage extends BaseResourceModel {
  constructor(
    public id?: number,
    public visivel_transparencia?: boolean,
    public aviso?: Aviso
  ) {
    super();
  }

  static converteJson(json: any): AvisoStorage {
    return Object.assign(new AvisoStorage(), json);
  }
}
